module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e4c882dd37a1d25a582067265eded81c.png";